import { combineReducers } from 'redux';
import message from './reducers/message';
import auth from './reducers/auth';

export default combineReducers({
  message,
  auth,
});
